/* debouncedresize: special jQuery event that happens once after a window resize https://github.com/louisremi/jquery-smartresize Copyright 2012 @louis_remi Licensed under the MIT license */
!function(e){var n,t,i=e.event;n=i.special.debouncedresize={setup:function(){e(this).on("resize",n.handler)},teardown:function(){e(this).off("resize",n.handler)},handler:function(e,r){var o=this,s=arguments,u=function(){e.type="debouncedresize",i.dispatch.apply(o,s)};t&&clearTimeout(t),r?u():t=setTimeout(u,n.threshold)},threshold:150}}(jQuery);

jQuery(function($) {

  var cartForm = $('#AddToCartForm');
  var addToCart = $('#AddToCart');
  var customDenomContainer;
  var denomSelector;
  var denomInput;
  var grid;
  var windowHeight = $(window).height();
  var footerOffsetTop = $('.site-footer').offset().top;
  var backToTop = $('.site-footer a.back-to-top');

   // Show/Hide Back to Top
  if (footerOffsetTop < windowHeight) {
    backToTop.hide()
  }

  $(window).on("debouncedresize", function( event ) {
    var newWindowHeight = $(window).height(),
        newFooterOffsetTop = $('.site-footer').offset().top;
    if (newFooterOffsetTop < newWindowHeight) {
      backToTop.hide();
    }
    else {
      backToTop.show();
    }
  });

  // Run our validation before adding to cart
  cartForm.on('submit', onCartSubmit)

  // Open the cart drawer after item added
  $('body').on('ajaxCart.afterCartLoad', function(evt, cart) {
    if (location.pathname !== '/cart') {
      timber.RightDrawer.open()
    }
    replaceAmountPropSign()
  })

  // Enable Cart Drawer && add to cart
  ajaxCart.init({
    formSelector: '#AddToCartForm',
    cartContainer: '#CartContainer',
    addToCartSelector: '#AddToCart',
    cartCountSelector: '#CartCount',
    cartCostSelector: '#CartCost',
    moneyFormat: null
  })

  replaceAmountPropSign()

  if (window.PRODUCT_TEMPLATE_PRESENT) {
    registerProductScripts()
  }

  // Main Nav Anchor Links
  $('.anchor-link').click(function(){
    var anchor = $(this).attr('href').replace('/','');
    if ($(anchor).length){
      var thisOffsetTop = $(anchor).offset().top;
      $('html, body').animate({scrollTop: thisOffsetTop}, 500);
      return false;
    }
  });

  // Back to Top
  $('.site-footer a.back-to-top').on('click', function(){
    $('html, body').animate({scrollTop: 0}, 500);
    return false;
  });

  // Preload product images
  var ProductImagesData = $('#PreloadProductImages').data('images');
  var ProductImages
  if (ProductImagesData) {
    ProductImages = ProductImagesData.split(",");
    for (var i = 0; i < ProductImages.length; i++) {
      $('#PreloadProductImages').append('<img src=' + ProductImages[i] + ' />');
    }
  }

  // Input with icon
  $('.input-icon input').each(function(){
    if($(this).is(":focus")){
      $(this).parent('.input-icon').addClass('focus');
    }
  });

  $('.input-icon input').focus(function(){
    $(this).parent('.input-icon').addClass('focus');
  });

  $('.input-icon input').blur(function(){
    $(this).parent('.input-icon').removeClass('focus');
  });

  // Contact Form Validation
  $('form[action*="/contact"]').on('submit', function(e) {
    var v = grecaptcha.getResponse(),
        emailValue = $(this).find('input[type="email"]').val(),
        bodyValue = $(this).find('textarea').val(),
        errorMsg = 'Please fix the following error(s):\n',
        errorCount = 0;
    if(emailValue == '' || !validEmail(emailValue)){
      errorMsg += '- fill in a valid email address.\n';
      errorCount++;
    }
    if(bodyValue == ''){
      errorMsg += '- fill in your message.\n';
      errorCount++;
    }
    if (!v.length) {
      errorCount++;
      errorMsg += '- complete the captcha.';
    }
    if (errorCount !== 0) {
      alert(errorMsg);
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  });

  function replaceAmountPropSign() {
    $('.ajaxcart__product-meta, .properties').each(function() {
      var el = $(this)
      var re = /Amount: \d+/
      if (re.test(el.text())) {
        el.text(el.text().replace('Amount: ', 'Amount: $'))
      }
    })
  }

  function registerProductScripts() {
    var product = CHSAPP.products['cenex-gift-card']

    new Shopify.OptionSelectors('productSelect', {
      product: product,
      onVariantSelected: selectCallback,
      enableHistoryState: true
    });

    prepareCustomColumn()

    if (product.variants.length) {
      $('.single-option-selector').filter(function(){
        return $(this).find('option').size() > 1;
      })
      .prepend('<option value="">Select</option>')
        .val('')
        .trigger('change');
    }

    if (product.options.length === 1 && product.options[0] !== 'Title') {
      $('.selector-wrapper:eq(0)')
        .prepend('<label for="productSelect-option-0">'+product.options[0]+'</label>');
    }

    if (product.options.length === 1 && product.options[0].indexOf('Default') > -1) {
      $('.selector-wrapper').hide();
    }

  }

  var amountIsValid = true;
  var customDenomInput
  var customDenomValMsg
  function prepareCustomColumn() {
    denomSel = $('#productSelect-option-1')
    denomContainer = denomSel.parent('.selector-wrapper')
    grid = $('<div class="grid"><div class="grid__item small-up--one-whole" /><div class="grid__item small-up--one-quarter hidden" /></div>')
    denomContainer.before(grid)

    var minCustom = CHSAPP.theme['min_custom_denom'];
    var maxCustom = CHSAPP.theme['max_custom_denom'];

    var customDenomLabel = $('<label>Amount ($)</label>')
    customDenomInput = $('<input type="number" ' +
                            // (minCustom ? ('min="' + minCustom + '" ') : '') +
                            // (maxCustom ? ('max="' + maxCustom + '" ') : '') +
                            ' style="width: 100%" name="properties[Amount]">')
    denomSelector = grid.find('.grid__item').first().append(denomContainer);
    customDenomContainer = grid.find('.grid__item').last().append(customDenomLabel, customDenomInput);
    customDenomValMsg = $('<span/>', { text: CHSAPP.theme.custom_denom_validation_msg }).css({
      'text-align': 'right',
      display: 'block',
      color: '#cc0000',
      'font-size': 12,
      'padding-bottom': 5
    }).hide()

    grid.last().after(customDenomValMsg)

    customDenomInput.on('keyup', function(e) {
      var onlyNumbers = /[^\d]/
      var val = $(this).val()
      val = parseInt(val.replace(onlyNumbers, ''), 10)
      $(this).val(val)
      amountIsValid = (val >= CHSAPP.theme.min_custom_denom && val <= CHSAPP.theme.max_custom_denom)

      setTimeout(function() {
        (isNaN(val))
          ? customDenomValMsg.text('Please specify an amount')
          : customDenomValMsg.text(CHSAPP.theme.custom_denom_validation_msg)
        amountIsValid ? customDenomValMsg.fadeOut() : customDenomValMsg.fadeIn()
      }, 200)
    })
  }

  function selectCallback(variant, selector) {
    if (customDenomInput) {
      customDenomValMsg.fadeOut()
    }
    timber.productPage({
      money_format: "",
      variant: variant,
      selector: selector
    });
    renderCustomColumn(/custom/i.test(variant ? variant.title : false))
  }

  function renderCustomColumn(shouldRender) {
    if (shouldRender) {
      denomSelector.removeClass('small-up--one-whole')
      denomSelector.addClass('small-up--three-quarters')
      customDenomContainer.removeClass('hidden')
      grid.append(customDenomContainer)
    } else {
      denomSelector.addClass('small-up--one-whole')
      denomSelector.removeClass('small-up--three-quarters')
      customDenomContainer = customDenomContainer.detach()
    }
  }

  function validEmail(value){
    return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
  }

  function onCartSubmit(e) {
    var self = this;
    if (!$(self).data('valid')) {
      e.preventDefault();
      e.stopImmediatePropagation()
      getCart()
        .then(validateCartState)
        .then(function() {
          if ($(self).data('valid')) {
            addToCart.trigger('click')
          }
        })
    } else {
      $(self).data('valid', false)
    }
  }

  function validateCartState(cart) {
    var valid = true;
    var itemAdding = $('#productSelect').val()
    var opt = $('option[value="' + itemAdding + '"]');
    var valueInCents = 0;
    var qty = parseInt($('#Quantity').val(), 10)
    var custom = opt.text().indexOf('Custom') > -1
    if (custom) {
      valueInCents = (parseInt($('input[name="properties[Amount]"]').val(), 10) * 100) * qty
      if (isNaN(valueInCents)
          || valueInCents > (CHSAPP.theme.max_custom_denom * 100)
          || valueInCents < (CHSAPP.theme.min_custom_denom * 100)
        ) {
        alert('Please specify a valid amount')
        valid = false
      }
    } else {
      valueInCents = (parseFloat(opt.data('price')) * 100) * qty
    }

    if (valid && (valueInCents + cart.total_price) > CHSAPP.theme.max_dollar_amount * 100) {
      alert(CHSAPP.theme.max_dollar_validation_msg)
      valid = false;
    }

    $(cartForm).data('valid', valid);

    if (custom && valid) {
      return submitItem(customChargeProduct.variants[0].id, valueInCents / 100, {})
        .then(getCart)
    }

    return cart
  }

  function validateQtyOfSurchargeItem(cart) {
    var qty = 0;
    $.each(cart.items, function(i, item) {
      if (item.handle === 'cenex-gift-card') {
        if (item.price === 0 && item.properties.Amount) {
          qty += (parseInt(item.properties.Amount, 10) * item.quantity)
        }
      }
    })
    return qty;
  }

  function getQtyOfSurchargeItem(cart) {
    var qty = 0;
    $.each(cart.items, function(i, item) {
      if (item.handle === 'custom-gift-card-charge') {
        qty = item.quantity
      }
    })
    return qty;
  }

  function getLinePosOfSurchargeItem(cart) {
    var pos = -1;
    $.each(cart.items, function(i, item) {
      if (item.handle === 'custom-gift-card-charge') {
        pos = i + 1
      }
    })
    return pos
  }

  // Submit multiple items to the cart, sequentially
  // returns Promise
  function submitItems(items) {
    var dfd = $.Deferred()
    function request(items) {
      var v;
      if (items.length) {
        v = items.shift()
        submitItem(v.variantId, v.qty, v.props)
          .then(function() {
            request(items)
          })
      } else {
        dfd.resolve()
      }
    }
    request(items)
    return dfd.promise()
  }

  // Add item to the cart, returns Promise
  function submitItem(variantId, qty, props) {
    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        'quantity': qty,
        'id': variantId,
        properties: props
      },
      dataType: 'json'
    })
  }

  // Get cart contents, returns Promise
  function getCart() {
    return $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).fail(onError)
  }

  // Ajax Callback Error
  function onError(xhr, textStatus) {
    // Shopify returns a description of the error in XMLHttpRequest.responseText.
    // It is JSON.
    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
    var data = JSON.parse(xhr.responseText)
    if (data && data.message) {
      alert(data.message + ': ' + data.description);
    } else {
      alert('An unknown error occured.');
    }
  }

  // Export these functions
  CHSAPP.getLinePosOfSurchargeItem = getLinePosOfSurchargeItem
  CHSAPP.validateQtyOfSurchargeItem = validateQtyOfSurchargeItem
  CHSAPP.getQtyOfSurchargeItem = getQtyOfSurchargeItem
  CHSAPP.getCart = getCart

});
